module.exports = __webpack_public_path__ + "static/assets/2383833e24e57a08ddb59bec95cedc67.svg";